module.exports = __webpack_public_path__ + "img/banner-dex-pn.c0a39c96.webp";